import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { withRouter } from 'react-router';
import styles from './style.module.css';
import * as Routes from '../../../../../constants/routes';
import { numberWithCommas, parseNumberWithCommas, logger } from '../../../../../helpers';
import { trackingEvent } from '../../../../../helpers/tracking';
import { onSubmit } from '../../../../../common/components/submit-button';
import RenderInput from '../../../../../common/components/render-input';

export const formName = Routes.STEPTWO;

const tracking = {
    eventAction: 'Mortgage Calculator - Step 2',
    eventLabel: 'Credit Score'
};

class StepTwoForm extends Component {
    render() {
        return (
            <form className={styles.form}>
                <Field
                    type='text'
                    name='loans'
                    label='Loans'
                    prefix='$'
                    format={numberWithCommas}
                    parse={parseNumberWithCommas}
                    component={RenderInput}
                />
                <Field
                    type='text'
                    name='carPayments'
                    label='Car Payments'
                    prefix='$'
                    format={numberWithCommas}
                    parse={parseNumberWithCommas}
                    component={RenderInput}
                />
                <Field
                    type='text'
                    name='linesOfCredit'
                    label='Lines of Credit'
                    prefix='$'
                    format={numberWithCommas}
                    parse={parseNumberWithCommas}
                    component={RenderInput}
                />
                <Field
                    type='text'
                    name='creditCards'
                    label='Credit Cards'
                    prefix='$'
                    format={numberWithCommas}
                    parse={parseNumberWithCommas}
                    component={RenderInput}
                />
                <Field
                    type='text'
                    name='other'
                    label='Other'
                    prefix='$'
                    format={numberWithCommas}
                    parse={parseNumberWithCommas}
                    component={RenderInput}
                />
            </form>
        );
    }
}

// Enhanced onSubmit with logging
const enhancedOnSubmit = async (values, dispatch, props) => {
    try {
        const result = await onSubmit(values, dispatch, props);
        logger.logFormSubmission('MortgageCalculator-Step2', values, true);
        return result;
    } catch (error) {
        logger.error('Step 2 form submission failed', {
            step: 2,
            formName: formName,
            values,
            error: error.message || error
        });
        throw error;
    }
};

StepTwoForm = reduxForm({
    form: formName,
    destroyOnUnmount: false,
    onSubmit: enhancedOnSubmit,
    initialValues: {
        loans: 0,
        carPayments: 0,
        linesOfCredit: 0,
        creditCards: 0,
        other: 0
    },
    redirectPath: `/mortgage${Routes.STEPTHREE}`,
    tracking: () => trackingEvent(tracking)
})(StepTwoForm);

export default withRouter(StepTwoForm);
